import React from "react";
import Tabs from "../../../componentsUI/estructura/tabs/Tabs.js";

import ParametrosInventario from "../parametros/inventarios/parametrosInventario.js";
import ParametrosCierre from "../parametros/sistema/parametroCierre.js";
import ParametrosProductos from "../parametros/producto/parametrosProductos.js";

import "./tabsTemplate.css";

export default function TabsAdministracionModulo() {
 const configuracionModuloTabs = [
    {
      id: "inventario",
      label: "Parametros Inventario",
      content: <ParametrosInventario />,
    },
    {
      id: "politicas",
      label: "Parametros de Cierre",
      content: <ParametrosCierre />,
    },
    {
      id: "producto",
      label: "Parametros Producto",
      content: <ParametrosProductos />,
    },
    
  ];

  return (
    <Tabs
      tabs={configuracionModuloTabs}
      defaultTabId="inventario"
    />
  );
}